import { Award, Users, BookOpen, ShieldCheck, ExternalLink } from 'lucide-react';

const stats = [
  { value: '5+', label: 'Learning Tracks', icon: BookOpen },
  { value: '30+', label: 'Lessons', icon: Award },
  { value: '3', label: 'Free Tools', icon: Users },
];

// Real, independently verifiable work — every link is live and checkable.
const proofPoints = [
  {
    name: 'Zane\'s Watch',
    url: 'https://zaneswatch.org',
    description: 'A free, anonymous dog-fighting reporting tool for Cuyahoga County. Built pro bono.',
  },
  {
    name: 'Cleveland Maennerchor',
    url: 'https://clevelandmaennerchor.com',
    description: 'The full website for Cleveland\'s German cultural center, running since 1873. Maintained pro bono.',
  },
  {
    name: 'northcoast.ai',
    url: 'https://northcoast.ai',
    description: 'Our consultancy — the father-and-son team that builds and teaches everything here.',
  },
];

export default function SocialProof() {
  return (
    <section className="py-12">
      {/* Stats */}
      <div className="grid grid-cols-3 gap-4 mb-12 max-w-2xl mx-auto">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center p-4 bg-gray-800/30 rounded-xl">
            <stat.icon className="w-6 h-6 text-accent-blue mx-auto mb-2" />
            <div className="text-2xl font-bold text-white">{stat.value}</div>
            <div className="text-sm text-gray-400">{stat.label}</div>
          </div>
        ))}
      </div>

      {/* The no-testimonials pledge — practicing what we teach */}
      <div className="max-w-3xl mx-auto bg-gray-800/50 border border-gray-700 rounded-xl p-8 text-center">
        <ShieldCheck className="w-8 h-8 text-accent-green mx-auto mb-4" aria-hidden="true" />
        <h2 className="text-2xl font-bold text-white mb-4">Why there are no testimonials here</h2>
        <p className="text-gray-300 mb-4">
          Most sites show you glowing quotes from &ldquo;Sarah K.&rdquo; and &ldquo;Marcus T.&rdquo;
          &mdash; people you can&rsquo;t look up, saying things you can&rsquo;t verify. We teach you
          to distrust exactly that. So we won&rsquo;t do it to you.
        </p>
        <p className="text-gray-300">
          When real learners say something about the Academy, we&rsquo;ll quote them with their
          permission and their real name. Until then: judge us by work you can check yourself.
        </p>
      </div>

      {/* Verifiable proof instead */}
      <div className="mt-12">
        <p className="text-sm text-gray-400 mb-6 text-center">
          Real things we&rsquo;ve built &mdash; click and check
        </p>
        <div className="grid gap-6 md:grid-cols-3">
          {proofPoints.map((proof) => (
            <a
              key={proof.name}
              href={proof.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-800/50 border border-gray-700 hover:border-accent-blue/50 rounded-xl p-6 transition-colors group"
            >
              <p className="font-medium text-white flex items-center gap-2">
                {proof.name}
                <ExternalLink className="w-4 h-4 text-gray-500 group-hover:text-accent-blue" aria-hidden="true" />
              </p>
              <p className="text-sm text-gray-400 mt-2">{proof.description}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
